import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  registerPage: boolean = false;

  constructor(
    private commonUtilService : CommonUtilService
  ) { }

  ngOnInit(): void {
    if(location.href.includes("/intro-registrazione") || location.href.includes("/logout")) {
      this.registerPage = true;
    }
  }

  logOut() {
    this.commonUtilService.logout();
 }
}
